<template>
  <el-dialog
    title="提示"
    :visible.sync="formVisible"
    :close-on-click-modal="false"
    width="800px"
  >
    <div class="tip-box flexs">
      <i class="el-icon-warning"></i>
      是否确认同意申请
      <span v-if="currentRow && currentRow.meeting && currentRow.meeting.title">
        （{{ currentRow.meeting.title }}）
      </span>
      <span v-if="cityCompanyName" style="margin-left: 10px; color: #409EFF;">
        {{ cityCompanyName }}
      </span>
    </div>
    <el-form
      ref="dataForm"
      label-position="right"
      :rules="formRules"
      :model="form"
      size="small"
      label-width="168px"
    >
      <el-form-item label="付款凭证：" prop="payOrderNums" class="width100">
        <div
          class="upload-box flexs"
          v-if="form.payOrderNums && form.payOrderNums.length > 0"
        >
          <div class="upload-img">
            <el-image
              style="width: 78px; height: 78px; margin: 0 5px 35px 0"
              :src="item.payImg"
              :preview-src-list="form.payOrderNums.map(i => i.payImg)"
              v-for="(item, index) in form.payOrderNums"
              :key="item.id || index"
            ></el-image>
          </div>
          <div class="upload-input">
            <div
              class="item"
              v-for="(item, index) in form.payOrderNums"
              :key="item.id || index"
            >
              <div class="flexs">
                <el-button
                  type="primary"
                  @click="getOcrTest(index)"
                  v-if="!item.ocrContent"
                  style="width: 120px;"
                >
                  OCR提取文字
                </el-button>
                <el-popover
                  v-else
                  placement="top-start"
                  title=""
                  width="400"
                  trigger="hover"
                  :content="item.ocrContent"
                >
                  <el-button slot="reference">查看OCR提取的信息</el-button>
                </el-popover>
                <div class="sp-col oper-icon" style="margin-left: 10px;">
                  <el-button
                    type="primary"
                    @click="handleCopyVoucher(index)"
                    size="small"
                    >复制凭证</el-button
                  >
                  <el-button
                    type="danger"
                    @click="handleDeleteVoucher(index)"
                    size="small"
                    >删除</el-button
                  >
                </div>
              </div>
              <div style="display: flex; align-items: flex-start;">
                <el-form-item
                  :prop="'payOrderNums.' + index + '.payBank'"
                  :rules="{
                    required: true,
                    message: '请选择收款银行',
                    trigger: 'change'
                  }"
                  class="cus-sty"
                  style="margin-right: 6px; margin-bottom: 0;"
                >
                  <el-select
                    v-model="item.payBank"
                    placeholder="请选择收款银行"
                    filterable
                    clearable
                  >
                    <el-option
                      :label="it.bankName"
                      :value="it.bankName"
                      v-for="(it, idx) in visibleBankOptions"
                      :key="idx"
                    ></el-option>
                  </el-select>
                  <el-button
                    type="text"
                    @click="toggleBankFilter"
                    style="margin-left: 6px;"
                  >
                    {{ showAllBanks ? "按城市过滤" : "显示全部" }}
                  </el-button>
                </el-form-item>
                <el-button type="text" @click="toggleBankFilter" style="white-space: nowrap;">
                  {{ showAllBanks ? '按城市过滤' : '显示全部' }}
                </el-button>
                <el-form-item
                  :prop="'payOrderNums.' + index + '.payNum'"
                  :rules="{
                    required: true,
                    message: '请输入支付单号',
                    trigger: 'blur'
                  }"
                  class="cus-sty"
                >
                  <el-input
                    v-model="item.payNum"
                    placeholder="请输入支付单号"
                  ></el-input>
                </el-form-item>
              </div>
              <div style="display: flex; align-items: center;">
                <el-form-item
                  :prop="'payOrderNums.' + index + '.payMoney'"
                  :rules="{
                    required: true,
                    message: '请输入付款金额',
                    trigger: 'blur'
                  }"
                  class="cus-sty"
                >
                  <el-input
                    v-model="item.payMoney"
                    placeholder="请输入付款金额"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  :prop="'payOrderNums.' + index + '.payTime'"
                  :rules="{
                    required: true,
                    message: '请选择付款日期',
                    trigger: 'change'
                  }"
                  class="cus-sty"
                >
                  <el-date-picker
                    v-model="item.payTime"
                    size="small"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="付款日期"
                  ></el-date-picker>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <div v-else style="color: #999; padding: 10px 0;">暂无付款凭证</div>
      </el-form-item>
      <el-form-item 
        v-if="availableAccountTypes && availableAccountTypes.length > 0"
        label="入账金额" 
        prop="giftAccountAmount" 
        class="width100"
      >
        <el-select
          v-model="form.giftAccountType"
          placeholder="请选择"
          style="width: 150px; margin-right: 10px;"
          @change="handleAccountTypeChange"
        >
          <el-option
            v-for="item in availableAccountTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          v-model="form.giftAccountAmount"
          placeholder="请输入入账金额"
          style="width: calc(100% - 160px);"
        ></el-input>
        <div style="font-size: 12px; color: #999; margin-top: 4px;">
          支持修改
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doApprove()" :loading="isLoading"
        >确认</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import rechargeRecordApi from "@/api/recharge/rechargeRecord";
import sysDataconstantApi from "@/api/config/sysDataconstant";
import meetingSignUpApi from "@/api/meeting/meetingSignUp";
import customerRegistrationApi from "@/api/cust/customerRegistration";
import customerRegistrationPayApi from "@/api/cust/customerRegistrationPay";

function initFormBean() {
  const formBean = {
    bankNum: "",
    upgradeGiftAmount: null,
    giftAccountType: null,
    giftAccountAmount: null,
    payOrderNums: [] // 改为对象数组，每个对象包含：id, payImg, payBank, payNum, payMoney, payTime, ocrContent, registrationId, dataType, state
  };
  return formBean;
}

export default {
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      isLoading: false,
      formRules: {
        bankNum: [
          {
            required: true,
            message: "请选择推送学费账户入账凭证",
            trigger: "change"
          }
        ]
      },
      currentRow: null,
      bankList: [],
      showAllBanks: false,
      cityCompanyId: null,
      cityCompanyName: "",
      availableAccountTypes: [] // 可用的账户类型选项
    };
  },
  computed: {
    filteredBankList() {
      // 仅显示已启用的银行
      const enabled = this.bankList.filter(it => String(it.isEnable) === "1");

      // 如果有城市公司ID，按城市ID过滤
      if (
        this.cityCompanyId !== null &&
        this.cityCompanyId !== undefined &&
        this.cityCompanyId !== ""
      ) {
        const cityIdNum = Number(this.cityCompanyId);
        return enabled.filter(it => Number(it.cityId) === cityIdNum);
      }

      // 未设置城市公司ID时，返回全部启用银行
      return enabled;
    },
    visibleBankOptions() {
      return this.showAllBanks
        ? this.bankList.filter(it => String(it.isEnable) === "1")
        : this.filteredBankList;
    }
  },
  created() {
    this.loadBankList();
  },
  methods: {
    /**
     * 加载银行列表
     */
    loadBankList() {
      sysDataconstantApi
        .fetchBatchCode({
          code: "lineUpMoneyBankType"
        })
        .then(({ data }) => {
          this.bankList =
            data.list[0] && data.list[0].content
              ? JSON.parse(data.list[0].content)
              : [];
        })
        .catch(() => {
          this.bankList = [];
        });
    },
    /**
     * OCR提取文字
     */
    getOcrTest(index) {
      if (
        !this.form.payOrderNums[index] ||
        !this.form.payOrderNums[index].payImg
      )
        return;
      return rechargeRecordApi
        .accurateOCR({ imageUrl: this.form.payOrderNums[index].payImg })
        .then(res => {
          this.$set(this.form.payOrderNums[index], "ocrContent", res.data);
        })
        .catch(() => {
          this.$message.error("OCR提取失败");
        });
    },
    /**
     * 复制凭证截图
     */
    handleCopyVoucher(index) {
      if (!this.form.payOrderNums[index]) return;
      const item = this.form.payOrderNums[index];
      // 二次确认
      this.$confirm("确认复制当前凭证信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // 调用接口创建新凭证
          customerRegistrationPayApi
            .create({
              state: 0,
              payImg: item.payImg,
              registrationId: item.registrationId || this.currentRow.id,
              dataType: item.dataType || 0
            })
            .then(res => {
              if (res.code === "0") {
                const newItem = res.data;
                // 清空需要重新填写的字段
                newItem.payBank = "";
                newItem.payNum = "";
                newItem.payMoney = "";
                newItem.payTime = "";
                newItem.ocrContent = item.ocrContent || "";
                this.form.payOrderNums.push(newItem);
                this.$message.success("复制成功");
              } else {
                this.$message.error(res.msg || "复制失败");
              }
            })
            .catch(error => {
              this.$message.error(error.msg || "复制失败");
            });
        })
        .catch(() => {
          // 用户取消，不执行任何操作
        });
    },
    /**
     * 删除凭证
     */
    handleDeleteVoucher(index) {
      const item = this.form.payOrderNums[index];
      if (!item) return;

      this.$confirm("确认删除该凭证信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // 如果有 id，调用删除接口
          if (item.id) {
            customerRegistrationPayApi
              .deleteById(item.id)
              .then(res => {
                if (res.code === "0") {
                  this.form.payOrderNums.splice(index, 1);
                  this.$message.success("删除成功");
                } else {
                  this.$message.error(res.msg || "删除失败");
                }
              })
              .catch(error => {
                this.$message.error(error.msg || "删除失败");
              });
          } else {
            // 如果没有 id（新添加但未保存的），直接从前端删除
            this.form.payOrderNums.splice(index, 1);
            this.$message.success("删除成功");
          }
        })
        .catch(() => {
          // 用户取消，不执行任何操作
        });
    },
    /**
     * 切换银行过滤模式
     */
    toggleBankFilter() {
      this.showAllBanks = !this.showAllBanks;
    },
    /**
     * 打开弹窗
     */
    handleCreate(row) {
      this.resetForm();
      this.currentRow = row;

      // 判断 userType 是否等于 20
      if (row.userType === 20) {
        // 使用用户的城市公司信息
        this.cityCompanyId = row.userCityCompanyId || null;
        this.cityCompanyName = row.userCityCompanyName || "";
      } else {
        // 判断 type 是否等于 40, 30, 10, 70
     
        // 将 type 转换为数字进行比较
        const typeNum = Number(row.userType);
        if ([40, 30, 10, 70].includes(typeNum)) {
          // 设置城市id为67，名字为"四川省杜一生教育管理有限公司"
          this.cityCompanyId = 67;
          this.cityCompanyName = "四川省杜一生教育管理有限公司";
        } else {
          this.cityCompanyId = null;
          this.cityCompanyName = "";
        }
      }

      this.formVisible = true;

      // 初始化付款凭证数据，转换为对象数组格式
      // 优先使用 payVouchersList，其次 payVoucherList，最后 payVouchers
      let voucherList = [];
      if (row.payVouchersList && row.payVouchersList.length > 0) {
        voucherList = row.payVouchersList;
      } else if (row.payVoucherList && row.payVoucherList.length > 0) {
        voucherList = row.payVoucherList;
      } else if (row.payVouchers && row.payVouchers.length > 0) {
        // 如果是字符串数组，转换为对象数组
        voucherList = row.payVouchers.map(img => ({
          payImg: img,
          payBank: "",
          payNum: "",
          payMoney: "",
          payTime: "",
          ocrContent: ""
        }));
      }

      // 转换为对象数组格式
      this.form.payOrderNums = voucherList.map(item => ({
        id: item.id || null,
        payImg: item.payImg || item,
        payBank: item.payBank || "",
        payNum: item.payNum || "",
        payMoney: item.payMoney || "",
        payTime: item.payTime || "",
        ocrContent: item.ocrContent || "",
        registrationId: item.registrationId || row.id,
        dataType: item.dataType || 0,
        state: item.state || 0
      }));

      // 设置默认的推送学费账户入账凭证
      const findBank = this.bankList.find(i => i.bankName === "学费赠送入账");
      if (findBank) {
        this.form.bankNum = findBank.bankName;
      }

      // 设置充值赠送金额
      if (row.upgradeGiftAmount !== undefined) {
        this.form.upgradeGiftAmount = row.upgradeGiftAmount;
      }

      // 调用接口获取入账金额明细
      if (row.id) {
        meetingSignUpApi
          .giftAmountDetailEstimate(row.id)
          .then(res => {
            // 初始化可用选项数组
            this.availableAccountTypes = [];
            // 先清空入账金额相关字段
            this.form.giftAccountType = null;
            this.form.giftAccountAmount = null;
            
            if (res && res.data && Object.keys(res.data).length > 0) {
              const data = res.data;
              // 账户类型映射：1-余额，2-零售价，3-学费赠送（体验班报名费上账走 3，漏了会把明细整个吞掉）
              const accountTypeMap = {
                1: "余额",
                2: "零售价",
                3: "学费赠送"
              };
              
              // 处理 giftAccounts 对象格式 {1: amount1, 2: amount2}
              // 情况1: data.giftAccounts 存在
              if (data.giftAccounts && typeof data.giftAccounts === "object" && Object.keys(data.giftAccounts).length > 0) {
                Object.keys(data.giftAccounts).forEach(key => {
                  const type = parseInt(key);
                  const amount = data.giftAccounts[key];
                  // 如果有金额值，添加到可用选项
                  if (amount && accountTypeMap[type]) {
                    this.availableAccountTypes.push({
                      value: type,
                      label: accountTypeMap[type],
                      amount: amount
                    });
                  }
                });
              } 
              // 情况2: data 本身就是 {1: amount1, 2: amount2} 格式（直接是 giftAccounts）
              else if (data.giftAccountType === undefined && data.giftAccountAmount === undefined) {
                // 检查 data 的键是否是数字（账户类型）
                Object.keys(data).forEach(key => {
                  const type = parseInt(key);
                  const amount = data[key];
                  // 如果键是数字且值也是数字，说明是账户类型和金额的映射
                  if (!isNaN(type) && !isNaN(amount) && amount && accountTypeMap[type]) {
                    this.availableAccountTypes.push({
                      value: type,
                      label: accountTypeMap[type],
                      amount: amount
                    });
                  }
                });
              }
              // 情况3: 处理单个类型和金额的情况
              else if (data.giftAccountType !== undefined && data.giftAccountAmount !== undefined) {
                const type = Number(data.giftAccountType);
                if (accountTypeMap[type]) {
                  this.availableAccountTypes.push({
                    value: type,
                    label: accountTypeMap[type],
                    amount: data.giftAccountAmount
                  });
                }
              }
              
              // 如果有可用选项，设置默认选中的类型和金额（取第一个）
              if (this.availableAccountTypes.length > 0) {
                const firstOption = this.availableAccountTypes[0];
                this.form.giftAccountType = firstOption.value;
                this.form.giftAccountAmount = firstOption.amount;
              }
            }
          })
          .catch(error => {
            console.error("获取入账金额明细失败:", error);
            // 接口失败时，清空选项和表单字段
            this.availableAccountTypes = [];
            this.form.giftAccountType = null;
            this.form.giftAccountAmount = null;
          });
      } else {
        // 没有id时，清空选项和表单字段
        this.availableAccountTypes = [];
        this.form.giftAccountType = null;
        this.form.giftAccountAmount = null;
      }

      this.$nextTick(() => {
        if (this.$refs["dataForm"]) {
          this.$refs["dataForm"].clearValidate();
        }
      });
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean();
      this.currentRow = null;
      this.showAllBanks = false;
      this.cityCompanyId = null;
      this.cityCompanyName = "";
      this.availableAccountTypes = [];
    },
    /**
     * 切换账户类型时，自动更新金额
     */
    handleAccountTypeChange(value) {
      const selectedOption = this.availableAccountTypes.find(item => item.value === value);
      if (selectedOption) {
        this.form.giftAccountAmount = selectedOption.amount;
      }
    },
    /**
     * 确认审核
     */
    doApprove() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          // 检查 currentRow 是否存在
          if (!this.currentRow || !this.currentRow.id) {
            this.$message.error("数据异常，请重新打开审核窗口");
            return;
          }

          this.isLoading = true;

          // 先保存凭证数据
          this.savePayOrderNums()
            .then(() => {
              // 构建 giftAccounts 对象
              const giftAccounts = {};
              if (this.form.giftAccountType && this.form.giftAccountAmount) {
                // 1-余额, 2-零售价, 3-学费
                giftAccounts[
                  this.form.giftAccountType
                ] = this.form.giftAccountAmount;
              }

              const params = {
                id: this.currentRow.id,
                giftAccounts: giftAccounts
              };

              // 调用审核通过接口
              this.$emit("approve", params, () => {
                this.isLoading = false;
                this.formVisible = false;
              });
            })
            .catch(error => {
              this.isLoading = false;
              this.$message.error(error.msg || "保存凭证数据失败");
            });
        }
      });
    },
    /**
     * 保存凭证数据
     */
    savePayOrderNums() {
      // 准备凭证数据，设置 state 和 dataType
      const payOrderNums = JSON.parse(JSON.stringify(this.form.payOrderNums));
      payOrderNums.forEach(item => {
        item.state = 1; // 已审核状态
        item.dataType = item.dataType || 50;
        // 删除不需要的字段
        delete item.createdBy;
        delete item.createdTime;
        delete item.ocrContent; // OCR内容不保存到后端
      });

      // 调用 setPayNum 接口保存凭证数据
      return customerRegistrationApi.setPayNum(payOrderNums).then(res => {
        if (res.code !== "0") {
          throw new Error(res.msg || "保存凭证数据失败");
        }
        return res;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.cus-sty {
  width: 220px;
  margin-bottom: 2px;
  margin-right: 2px;
}
.tip-box {
  margin-bottom: 20px;
  display: flex;
  align-items: center;

  i {
    font-size: 24px;
    margin-right: 10px;
    color: #e6a23c;
  }
}
.upload-box {
  align-items: flex-start;
  display: flex;
  .upload-img {
    width: 80px;
    margin-right: 10px;
  }
  .upload-input {
    width: calc(100% - 80px);
    .item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: 70px;
      margin-bottom: 18px;
    }
  }
}
::v-deep .el-select {
  width: 100%;
}
.oper-icon {
  i {
    cursor: pointer;
    font-size: 22px;
    color: #465c99;
    &:nth-child(1) {
      padding-right: 5px;
    }
  }
}
.flexs {
  display: flex;
  align-items: center;
}
</style>
